import styled, { css } from 'styled-components';

interface HeaderProps {
  isHomePage?: boolean;
}

export const HeaderContainer = styled.header<HeaderProps>`
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-basis: 65px;
  flex-shrink: 0;
  //min-width: 360px;
  ${(props) =>
    props.isHomePage &&
    css`
      position: relative;
      z-index: 2;
    `
  }
  @media screen and (max-width: 960px) {
    flex-basis: 45px;
    align-items: flex-end;
    justify-content: center;
    align-items: center;
    //padding: 0px 10px;
    padding: 0 0px;
    &.headerPage {
      justify-content: start;
    }
    &.mobile {
      margin: 0px 20px 0 20px;
    }
  }
`;

export const DivContent = styled.div<HeaderProps>`
  display: flex;
  align-items: center;
  
  gap: 25px;
  z-index: 1;
  color: ${(props) => props.theme.colors.textHeader};
  svg {
    font-size: 14px;
  }

  ${(props) =>
    props.isHomePage &&
    css`
      @media screen and (max-width: 960px) {
        width: 100%;
        justify-content: space-between;
      }
    `
  }

  @media screen and (max-width: 960px) {
    svg {
      font-size: 14px;
    }
    &.mobile{
      width: 100%;
    }
    &.hide {
      display: none;
    }
  }
  @media (max-width: 640px) {
    &:has(#support) {
      > button {
       // width: 40%;
        padding: 0;
        font-size: 10px;
      }
    }
  }
`;

